<template>
  <div>
    <v-container v-if="myloadingvariable">
      <v-dialog v-model="alert.type" max-width="390" transition="scale-transition">
        <v-card>
          <v-card-title :class="alert.color">
            {{ alert.title }}
          </v-card-title>

          <v-card-text>
            {{ alert.message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="alert.type = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template cols="6" sm="12" md="6">
        <v-data-table :headers="headers" :items="qcSampling" class="elevation-3" :search="search">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>QC Sampling</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>

              <v-text-field
                class="font-size: 12px; mx-8"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small class="ma-2 green--text" outlined @click="updateTestResult(item, 'Pass')">
              Pass
            </v-btn>
            <v-btn small class="ma-2 red--text" outlined @click="updateTestResult(item, 'Fail')">
              Fail
            </v-btn>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ formatDate(item.current_date) }}
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize"> Reset </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-container>
    <v-container class="indicator" v-if="!myloadingvariable">
      <v-progress-circular :size="50" :width="5" color="orange" indeterminate></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    elapse: null,
    alert: {
      color: "info",
      title: null,
      message: null,
      type: null,
    },
    valid: true,
    dialog: false,
    menu2: false,
    menu3: false,
    dialogDelete: false,
    expanded: [],
    myloadingvariable: false,
    singleExpand: true,
    search: "",
    headers: [
      { text: "Sampler Name", value: "sampler_name" },
      { text: "Field ID", value: "farm_id" },
      { text: "Expected overallyield", value: "expected_overall_yield" },
      { text: "Sample ID", value: "sampler_id" },
      { text: "Plucking Quantity", value: "plucking_quantity" },
      { text: "Plucking No", value: "plucking_number" },
      { text: "Date", value: "date" },
      { text: "Staff Name", value: "user_name" },
      { text: "Test Result", value: "actions", sortable: false },
    ],

    qcSampling: [],
    editedIndex: -1,
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      axios
        .get("qc-sampling")
        .then((res) => {
          this.qcSampling = res.data;
          this.filterQC();
          this.myloadingvariable = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterQC() {
      this.qcSampling = this.qcSampling.filter((item) => {
        if (item.test_result === "Pending") {
          return item;
        }
      });
    },

    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },

    async updateTestResult(item, status) {
      console.log(status);
      console.log(item);

      await axios
        .patch(`qc-sampling/test-result/${item.qc_sampling_id}`, {
          test_result: status,
        })
        .then((res) => {
          if (res.data) {
            this.alert.color = "green--text";
            this.alert.title = "Success";
            this.alert.message = "Test Result Updated";
            this.alert.type = true;
            this.initialize();
          }
        })
        .catch((err) => {
          this.alert.color = "red--text";
          this.alert.title = "Error";
          this.alert.message = err.message;
          this.alert.type = true;
        })
        .finally(() => {
          this.close();
        });
    },

    deleteItem(item) {
      this.editedIndex = this.qcSampling.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    getMax(arr, prop) {
      let max;
      for (var i = 0; i < arr.length; i++) {
        if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop])) max = arr[i];
      }
      return max;
    },
    deleteItemConfirm() {
      axios
        .delete("qcSampling/" + this.editedItem.id)
        .then((res) => {
          if (res.code === 200) {
            // this.$swal(res.data.message);
            this.alert.color = "green--text";
            this.alert.title = "Success";
            this.alert.message = "Brand Deleted";
            this.alert.type = true;
            this.qcSampling.splice(this.editedIndex, 1);
          }
        })
        .catch((err) => {
          // this.$swal("Sorry, There is an error : " + err.message);

          this.alert.color = "red--text";
          this.alert.title = "Error";
          this.alert.message = err.message;
          this.alert.type = true;
        })
        .finally(() => {
          this.alert.color = "green--text";
          this.alert.title = "Success";
          this.alert.message = "Brand Deleted";
          this.alert.type = true;
          this.qcSampling.splice(this.editedIndex, 1);
          this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.reset();
      });
    },

    async closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    formatDate(date) {
      let monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      //  month = "" + (d.getMonth() + 1),
      var d = new Date(date),
        month = "" + monthNames[d.getMonth()],
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // var d = dateVar.add(-1).day().toString('dd-MMM-yyyy');

      return [day, month, year].join(" - ");
    },
  },
};
</script>
<style>
.compact-form {
  transform: scale(0.865);
  transform-origin: center;
}
.v-progress-circular {
  position: absolute;
  top: 100%;
  left: 50%;
}
.indicator {
  height: 40vh;
}
</style>
